/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountLogsPage} from '../models/AccountLogsPage';
import type {AccountLogsPageRequest} from '../models/AccountLogsPageRequest';
import type {DetailedLogHits} from '../models/DetailedLogHits';
import type {Error} from '../models/Error';

export interface GetAccountLog$Request {
    accountId: number;
    accountLogsPageRequest: AccountLogsPageRequest;
}

export interface GetAccountLog$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountLogRequest = createAction<PayloadData<void, GetAccountLog$Request>>('ACCOUNT_LOG__GET_ACCOUNT_LOG__REQUEST');
export const getAccountLogSuccess = createAction<PayloadData<AccountLogsPage, GetAccountLog$Request>>('ACCOUNT_LOG__GET_ACCOUNT_LOG__SUCCESS');
export const getAccountLogFailure = createAction<PayloadData<Error, GetAccountLog$Request, true>>('ACCOUNT_LOG__GET_ACCOUNT_LOG__FAILURE');

export const getAccountLogActions = [
    getAccountLogRequest,
    getAccountLogSuccess,
    getAccountLogFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {AccountLogsPageRequest} meta.accountLogsPageRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountLog = (meta: GetAccountLog$Request, config?: GetAccountLog$Config) => {
    return {
        CALL_API: {
            types: getAccountLogActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/change-logs`,
            TRANSPORT_REQUEST_BODY: meta.accountLogsPageRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAccountLogById$Request {
    logId: string;
}

export interface GetAccountLogById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountLogByIdRequest = createAction<PayloadData<void, GetAccountLogById$Request>>('ACCOUNT_LOG__GET_ACCOUNT_LOG_BY_ID__REQUEST');
export const getAccountLogByIdSuccess = createAction<PayloadData<DetailedLogHits, GetAccountLogById$Request>>('ACCOUNT_LOG__GET_ACCOUNT_LOG_BY_ID__SUCCESS');
export const getAccountLogByIdFailure = createAction<PayloadData<Error, GetAccountLogById$Request, true>>('ACCOUNT_LOG__GET_ACCOUNT_LOG_BY_ID__FAILURE');

export const getAccountLogByIdActions = [
    getAccountLogByIdRequest,
    getAccountLogByIdSuccess,
    getAccountLogByIdFailure
] as const;

/**
 * @param {string} meta.logId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountLogById = (meta: GetAccountLogById$Request, config?: GetAccountLogById$Config) => {
    return {
        CALL_API: {
            types: getAccountLogByIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/change-log/${meta.logId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

